import { getContextualRequest, normalizeUPApiError } from '../../../../modules/utils/index.js';
import { mapProductsLite } from './mapper.js';
export async function fetchProducts(client, params) {
    try {
        const visibilityContext = params?.visibilityContext;
        const postalCode = params?.postalCode;
        const tags = params?.tags;
        const req = await getContextualRequest(client);
        const res = await req
            .get(`${client.context.api.host}/subscriptions/products`)
            .query({
            ...(visibilityContext && { visibility_context: visibilityContext }),
            ...(postalCode && { postal_code: postalCode }),
            ...(tags && { tags }),
        });
        return res.body;
    }
    catch (error) {
        throw normalizeUPApiError(error);
    }
}
// lite version of the fetchProducts function
// it uses the mapper that maps the channel arrays to only include channel IDs
// rather than the full channel objects
export async function fetchProductsLite(client, params) {
    try {
        const visibilityContext = params?.visibilityContext;
        const postalCode = params?.postalCode;
        const tags = params?.tags;
        const req = await getContextualRequest(client);
        const res = await req
            .get(`${client.context.api.host}/subscriptions/products`)
            .query({
            ...(visibilityContext && { visibility_context: visibilityContext }),
            ...(postalCode && { postal_code: postalCode }),
            ...(tags && { tags }),
        });
        return mapProductsLite(res.body, tags);
    }
    catch (error) {
        throw normalizeUPApiError(error);
    }
}
